import { Button, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Alert } from '@mui/material';
import { ButtonLoading } from 'components';
import OperationDialog from '../../InvoiceDebtor/components/OperationDialog';
import {
  payInvoiceWithCredit,
  getCarTableList,
  postCartableFactor,
} from '../../services/DetailAccountsServices';
import useCustomHook from '../hooks';

export default function PaymentWithCreditDialog({
  open,
  setOpen,
  invoice,
  tableRef,
  setRequestId,
  setIsOpenMessageCartableDg,
}) {
  const { loading, setLoading } = useCustomHook();

  const classes = useStyle();
  const onPayment = async () => {
    try {
      setLoading(true);
      const cartableList = await getCarTableList({
        wallet: 'PODLAND_WALLET',
        typeCode: 'MULTI_CONFIRMATION_TYPE_INVOICE',
        offset: '0',
        size: '10',
      });
      if (
        cartableList?.result?.length > 0 &&
        cartableList?.result[0]?.multiConfirmationSrv?.enable &&
        !cartableList?.result[0]?.multiConfirmationSrv?.left
      ) {
        // کارتابل
        const data = {
          cartableId: cartableList?.result[0]?.multiConfirmationSrv?.id,
          invoiceId: invoice?.invoiceId,
          wallet: 'PODLAND_WALLET',
        };
        const cartableFactor = await postCartableFactor(data);
        setRequestId(cartableFactor?.result?.id);
        setIsOpenMessageCartableDg(true);
      } else {
        // غیر کارتابلی است
        const payInvoice = await payInvoiceWithCredit(invoice.invoiceId);
        tableRef?.current?.onQueryChange?.();
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
    }
  };
  return (
    <OperationDialog title="پرداخت با حساب دیجیتال" open={open} setOpen={setOpen}>
      <div className={classes.container}>
        <Alert severity="info" className={classes.alert}>
          آیا مایل به پرداخت فاکتور با استفاده از موجودی حساب دیجیتال خود هستید؟
        </Alert>
        <Grid
          md={12}
          xs={12}
          lg={12}
          style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '16px', gap: '15px' }}
        >
          <ButtonLoading
            name="بله"
            color="primary"
            variant="contained"
            loading={loading}
            onClick={onPayment}
            className={classes.button}
          />
          <Button onClick={() => setOpen(false)} className={classes.button}>
            خیر
          </Button>
        </Grid>
      </div>
    </OperationDialog>
  );
}

const useStyle = makeStyles(() => ({
  title: { fontSize: '1.5em' },
  alert: {
    paddingTop: '.5em',
    paddingBottom: '.5em',
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    marginTop: '1em',
  },
}));
